import { render, staticRenderFns } from "./clockIconNew.vue?vue&type=template&id=44975e5e"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44975e5e')) {
      api.createRecord('44975e5e', component.options)
    } else {
      api.reload('44975e5e', component.options)
    }
    module.hot.accept("./clockIconNew.vue?vue&type=template&id=44975e5e", function () {
      api.rerender('44975e5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/clockIconNew.vue"
export default component.exports